export default "__VITE_ASSET__BYRo8rfi__"